export const EmailIcon = ({ width = 24, height = 24, color = "currentColor", className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 6L12 13L2 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



export const PhoneIcon = ({ width = 24, height = 24, color = "currentColor", className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22 16.92V19.92C22 20.47 21.55 20.93 21 20.98C20.5 21.03 19.95 21 19.42 20.88C16.36 20.21 13.53 18.77 11.23 16.47C8.93 14.17 7.49 11.34 6.82 8.28C6.7 7.75 6.67 7.2 6.72 6.7C6.77 6.15 7.23 5.7 7.78 5.7H10.78C11.18 5.7 11.53 5.95 11.63 6.34C11.83 7.16 12.16 7.94 12.61 8.65C12.77 8.92 12.73 9.27 12.51 9.49L11.41 10.59C12.83 12.82 14.88 14.87 17.11 16.29L18.21 15.19C18.43 14.97 18.78 14.93 19.05 15.09C19.76 15.54 20.54 15.87 21.36 16.07C21.75 16.17 22 16.52 22 16.92Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const ContactFormIcon = ({ width = 24, height = 24, color = "currentColor", className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 13H8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 17H8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 9H8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 2V8H20"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

